module.exports = __webpack_public_path__ + "static/media/list-white.814c7e5b.svg";